<template lang="html">
  <root class="admin-update-due-payment">

    <admin-nav></admin-nav>
    <page-header name="Due payments" :count='false'></page-header>

    <!-- Data -->
    <div class="container">
      <div class="row">
        <div class="col m6 offset-m3">
          <table class="striped">
            <tbody>
              <tr>
                <th>Current due</th>
                <td>{{ Number(current_due).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col m6 offset-m3">
          <div class="mui-textfield">
            <label>Paid Amount</label>
            <input type="number" v-model="paid_amount"
            maxlength="7" 
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col m4 offset-m4">
          <a class="waves-effect waves-light btn" :disable="isSending" @click="update">Update</a>
        </div>
      </div>
    </div>
  </root>

</template>

<script>
import * as firebase from 'firebase'

export default {
  data() {
    return {
      current_due: '',
      paid_amount: '',

      isSending: false,
    }
  },

  methods: {
    collect() {
      let userKey = this.$route.params.userKey

      firebase.database()
        .ref('users/'+ userKey +'/due_payments')
        .on('value', duePaymentsSnap => {
          this.current_due = duePaymentsSnap.val()
        })
    },

    update() {
      let userKey = this.$route.params.userKey

      if(!this.paid_amount) {
        Materialize.toast("All fields are required", 4000)
        return
      }

      if(!this.current_due || this.current_due < this.paid_amount || this.paid_amount <= 0)
      {
        Materialize.toast("Please check the paid amount", 4000)
        return
      }

      this.isSending = true
      let netPay = this.current_due - this.paid_amount

      firebase.database()
        .ref('users/'+ userKey)
        .update({ due_payments: netPay })
        .then( () => {
          Materialize.toast("Updated", 4000)
        })
    }
  },

  // Mounted
  mounted() {
    this.collect()
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Admin/UpdateDuePayment.vue